import { all, takeLatest } from "redux-saga/effects";
/* ------------- Connect Types To Sagas ------------- */
function* rootSaga() {
  yield all([
    // auth
    // lecture
  ]);
}

export default rootSaga;
